export default __webpack_public_path__ + "static/media/bonus.511f13d3.svg";